import moment from 'src/app/utils/moment';

export interface UserGoalMeasurement {
  start: number;
  target: number;
  type: string;
}

export class UserGoal {
  id: string = null;
  title: string = null;
  startDate: string = null;
  endDate: string = null;
  status: "scheduled" | "active" | "complete";
  organization: string;
  description?: string;
  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  measurementStart: number;
  measurementStartSecondary: number;
  measurementType: string;
  measurementTarget: number;
  measurementTypeSecondary: string;
  measurementTargetSecondary: number;
  measurements: UserGoalMeasurement[];
  
  constructor(init: Partial<UserGoal>) {
    Object.assign(this, init);
  }
}